// Floating "HD" / "Ultra HD" tag for a generated photo made at a higher quality tier (nothing for Normal) — a small dark glass
// pill, only the icon is tinted. The caller positions it (e.g. `absolute left-2 top-2` on the image box).
import { useTranslation } from 'react-i18next';
import { IconCrown, IconSparkles } from '@tabler/icons-react';
import { cn } from '@/lib/utils';

export default function QualityBadge({ quality, size = 'md', className }) {
    const { t } = useTranslation();
    if (quality !== 'hd' && quality !== 'ultra') return null;
    const ultra = quality === 'ultra';
    const Icon = ultra ? IconCrown : IconSparkles;
    return (
        <span
            className={cn(
                'pointer-events-none inline-flex items-center gap-0.5 rounded-md bg-black/55 font-semibold leading-none text-white backdrop-blur-sm',
                size === 'sm' ? 'px-1 py-0.5 text-[8px]' : 'px-1.5 py-[3px] text-[10px]',
                className,
            )}
        >
            <Icon size={size === 'sm' ? 8 : 10} strokeWidth={2.4} className={ultra ? 'text-amber-300' : 'text-sky-300'} />
            {t(ultra ? 'imageGeneration.quality.badgeUltra' : 'imageGeneration.quality.badgeHd')}
        </span>
    );
}
